document.addEventListener('DOMContentLoaded', function() {

  /* 
    URL APP: https://apps.shopify.com/dondy-whatsapp-chat-widget
    Crear archivo en assets/custom_script.js
    una vez creado
    Agregar en layout/theme.liquid
    <script src="{{ 'custom_script.js' | asset_url }}" defer="defer"></script>
    plugin que usamos para whatsapp y que nos deja medir: Dondy: WhatsApp Chat+Marketing
    */
  /*
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          // Intentar encontrar el elemento con el ID 'whatsapp-link'
          const whatsappLink = document.getElementById("whatsapp-link");
          if (whatsappLink) {
            console.log('Elemento con ID "whatsapp-link" detectado en el DOM');
            // Agregar evento click para enviar eventos de tracking
            whatsappLink.addEventListener("click", () => {
              console.log("Clic en WhatsApp detectado");
              if (typeof gtag === "function") {
                gtag("event", "adw_whatsapp_chat");
              }
              if (typeof fbq === "function") {
                fbq("track", "Contact", { content_name: "whatsapp" });
              }
            });
            // Detener la observación una vez encontrado
            observer.disconnect();
            break;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    */

  /*
  * APP: https://apps.shopify.com/whatsapp-sharing
  */
    window.spWhatsAppTrack = function(buttonType){
       if(buttonType == 'widgetButton'){
            if (typeof gtag == 'function') {
                gtag("event", "adw_click_whatsapp_chat");
            };
            if (typeof ga == 'function') {
                ga('send', 'event', 'telefono', 'click', 'whatsapp');
            };
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'whatsapp' });
            };
           console.log('click in whatsapp');
         
       }
    };

  // jQuery is not loaded
  console.log("without jquery load");

  /**
   * Activacion e incrustación de clases para eventos
   */
  document.querySelectorAll('a[href^="tel"]').forEach((element) => {
    element.classList.add("link-phone");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_phone");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "telefono" });
      }
    });
  });
  document.querySelectorAll('a[href^="mailto"]').forEach((element) => {
    element.classList.add("link-email");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_email");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "email" });
      }
    });
  });
  document.querySelectorAll('a[href*="wa.me"]').forEach((element) => {
    element.classList.add("link-whatsapp");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_whatsapp");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "whatsapp" });
      }
    });
  });
  document.querySelectorAll('a[href*="api.whatsapp"]').forEach((element) => {
    element.classList.add("link-whatsapp");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_whatsapp");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "whatsapp" });
      }
    });
  });
  document.querySelectorAll('a[href*="m.me"]').forEach((element) => {
    element.classList.add("link-messenger");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_messenger");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "messenger" });
      }
    });
  });
  document.querySelectorAll('a[href*="maps.google"]').forEach((element) => {
    element.classList.add("link-map");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_map");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "maps" });
      }
    });
  });
})